var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',{staticClass:"page-title-box d-md-flex justify-content-between"},[_c('div',[_c('h3',[_vm._v("Painel do PAD")]),_c('p')])]),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._v(" Seja bem-vindo ao PAD! ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }